<template>
  <el-dialog :visible.sync="visible"  @close="qx()" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form label-width="50px"  v-loading="myLoading" :model="dataForm" :rules="dataRule"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '130px' : '130px'">
     <div class="dialog_box">
      <div class="dia_item">
        <div class="dia_title">付款方</div>
        <el-form-item label="资金方" prop="userId" class="styW">
          <el-select class="sandh" v-model="dataForm.userId" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in fundList"
              :key="item.userId"
              :label="item.deptName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付金额(元)" prop="totalAmount" class="styW">
          <el-input v-model="dataForm.totalAmount" placeholder="请输入支付金额"></el-input>
        </el-form-item>
        <el-form-item label="支付密码" prop="password" class="styW">
          <div id="ipt_pwd2" class="ipt_pwd">
            <!-- <span id="LOGPASS2_SHOW2">请输入支付密码</span> -->
            <el-input id="LOGPASS2" class="default input_search" type="password" v-model="dataForm.password" placeholder="请输入支付密码" disabled="disabled"></el-input>
            <div id="keyboardBtn2" class="ipt_pwd_rjp default"></div>
          </div>
         
        </el-form-item>
      </div>
      <div>
        <div class="dia_title">收款方</div>
        <el-form-item label="中运小贷" prop="accountType" class="styW">
          <el-select class="sandh" v-model="dataForm.accountType" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in loanType"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型" prop="txnPurpose" class="styW">
          <el-select class="sandh" v-model="dataForm.txnPurpose" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in costType"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
     </div>
    </el-form>
    <template slot="footer">
      <el-button @click='qx()'>{{ $t('cancel') }}</el-button>
      <el-button type="primary" :disabled="isButton" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'

export default {

  data () {
    return {
      visible:false,
      isButton:false,
      myLoading:false,
      options:{},
      passwordInstance:'',
      dataForm:{
        userId:'',
        totalAmount:'',
        password:'',
        accountType:'',
        txnPurpose:'',
      },
      costType:[
        {label:'年费',value:'1'},
        {label:'月结费用',value:'2'},
      ],
      loanType:[
        {label:'手续费账户',value:'1'},
      ],
      fundList:[],
    }
  },
  computed: {
    dataRule(){
      return {
        userId:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalAmount:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountType:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        txnPurpose:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
      }
    }
  },
  
  methods: {
    init(){
      this.getFactor()
      this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
      })
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
             
      })
    },
    getFactor () {
      this.$http.get('/api/trans/getRandom').then(r => {
        if(r.data.code == '0'){
          console.log(12,r.data.data)
          this.options = r.data.data
          this.passwordInstance = this.initPassword(this.options)
        }else{
          this.$message({
            type:"error",
            message:"获取随机因子失败"
          })
        }
        })
  },
    initPassword(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn2", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS2", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd2", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "",
        keyBordTop: "",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      })
      passowrd.initOptions()
      return passowrd
    },
    qx(){
      this.visible = false
      this.passwordInstance.clearPWD()
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.passwordInstance.setRandKey(this.options.random_value) // 先设置随机key
      const password = this.passwordInstance.getOutputSM() // 国密加密密码
      this.dataForm = {
        ...this.dataForm,
        password,
        postscript:"暂无说明",
        randomKey: this.options.random_key
      }
      
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('api/service/charge/transferServiceCharge',this.dataForm).then(({ data: res })=>{
         
            if(res.code == '0'){
              this.passwordInstance.clearPWD()
              this.$message({
                type: 'success',
                message:res.data.ret_msg
              })
              this.visible = false
              this.$emit('refreshDataList')

            }else{
              this.$message({
                type: 'error',
                message:res.msg
              })
            }
         
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })

  },
 
}
</script>

<style lang="scss" scoped>
  .dialog_box{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .dia_title{
      font-size: 22px;
      font-weight: bold;
      margin:30px 52px;
    }
    .styW{
      width: 400px;
    }
    .sandh{
      width: 100%;
    }
  }
  ::v-deep .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    color: rgb(96,98,102);
  }
</style>
